import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import api, { BASE_URL, fotoUrl } from '../api';
import { useTheme } from '../contexts/ThemeContext';

const Hakedis: React.FC = () => {
  usePageTitle('Hakediş');
  const { isDark } = useTheme();
  const card      = isDark ? '#1a1a1a' : 'white';
  const cardAlt   = isDark ? '#1e1e1e' : '#f8f8f8';
  const border    = isDark ? '#2a2a2a' : '#eee';
  const borderSub = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec   = isDark ? '#999' : '#888';
  const textMuted = isDark ? '#666' : '#aaa';

  const [egitmenler, setEgitmenler] = useState<any[]>([]);
  const [secili, setSecili] = useState<any>(null);
  const [detay, setDetay] = useState<any>(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [detayYukleniyor, setDetayYukleniyor] = useState(false);
  const [odemeModal, setOdemeModal] = useState(false);
  const [odemeForm, setOdemeForm] = useState({ odenen_tutar:'', odeme_yontemi:'Nakit', odeme_tipi:'tam', aciklama:'' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  const yukle = () => {
    setYukleniyor(true);
    api.get('/api/hakedis').then(r => setEgitmenler(r.data)).finally(() => setYukleniyor(false));
  };
  useEffect(() => { yukle(); }, []);

  const egitmenSec = async (e: any) => {
    setSecili(e);
    setDetayYukleniyor(true);
    try {
      const res = await api.get(`/api/hakedis/${e.id}`);
      setDetay(res.data);
    } catch (err) { console.error(err); }
    finally { setDetayYukleniyor(false); }
  };

  const odemeKaydet = async () => {
    if (!odemeForm.odenen_tutar) { setHata('Tutar zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const res = await api.post('/api/hakedis/ode', {
        egitmen_id: secili.id,
        odenen_tutar: parseFloat(odemeForm.odenen_tutar),
        odeme_yontemi: odemeForm.odeme_yontemi,
        odeme_tipi: odemeForm.odeme_tipi,
        aciklama: odemeForm.aciklama,
      });
      alert(res.data.mesaj);
      setOdemeModal(false);
      setOdemeForm({ odenen_tutar:'', odeme_yontemi:'Nakit', odeme_tipi:'tam', aciklama:'' });
      yukle();
      egitmenSec(secili);
    } catch (err:any) { setHata(err.response?.data?.hata || 'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const RENKLER = [['#EEEDFE','#3C3489'],['#E1F5EE','#085041'],['#FBEAF0','#72243E'],['#FAEEDA','#854F0B'],['#E6F1FB','#0C447C']];

  return (
    <div style={{ padding:24 }}>
      <h1 style={{ fontSize:22, fontWeight:600, margin:'0 0 20px', color: textPrimary }}>Ogretmen hakedisi</h1>

      <div style={{ display:'grid', gridTemplateColumns:'300px 1fr', gap:16 }}>
        {/* Sol panel - egitmen listesi */}
        <div>
          {yukleniyor ? <div style={{ color: textSec, fontSize:13 }}>Yukleniyor...</div> : (
            egitmenler.map((e, i) => {
              const [bg, tc] = RENKLER[i % RENKLER.length];
              const bekleyen = parseFloat(e.bekleyen || 0);
              return (
                <div key={e.id} onClick={() => egitmenSec(e)}
                  style={{
                    background: secili?.id === e.id ? '#534AB7' : card,
                    border: secili?.id === e.id ? '2px solid #534AB7' : `1px solid ${border}`,
                    borderRadius:10, padding:14, marginBottom:8, cursor:'pointer',
                  }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    {e.foto_url
                      ? <img src={fotoUrl(e.foto_url)} alt="" style={{ width:34, height:34, borderRadius:'50%' }} />
                      : <div style={{ width:34, height:34, borderRadius:'50%', background:bg, color:tc, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:600 }}>
                          {e.ad?.charAt(0)}{e.soyad?.charAt(0)}
                        </div>
                    }
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:600, fontSize:13, color: secili?.id === e.id ? 'white' : textPrimary }}>{e.ad} {e.soyad}</div>
                      <div style={{ fontSize:11, color: secili?.id === e.id ? 'rgba(255,255,255,0.7)' : textMuted }}>
                        Bekleyen: ₺{parseFloat(e.bekleyen||0).toLocaleString('tr-TR')}
                      </div>
                    </div>
                    {bekleyen > 0 && (
                      <span style={{ background: secili?.id === e.id ? 'rgba(255,255,255,0.2)' : (isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA'), color: secili?.id === e.id ? 'white' : '#854F0B', borderRadius:20, padding:'2px 8px', fontSize:10, fontWeight:500 }}>
                        Bekliyor
                      </span>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Sag panel - detay */}
        <div>
          {!secili ? (
            <div style={{ background: card, border: `1px dashed ${border}`, borderRadius:10, padding:40, textAlign:'center', color: textMuted }}>
              Sol taraftan bir egitmen secin
            </div>
          ) : detayYukleniyor ? (
            <div style={{ color: textSec, fontSize:13 }}>Yukleniyor...</div>
          ) : detay && (
            <div>
              {/* Ozet kartlar */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:10, marginBottom:16 }}>
                {[
                  { label:'Toplam birikmis', value:`₺${parseFloat(detay.ozet?.toplam_birikmis||0).toLocaleString('tr-TR')}`, bg: cardAlt },
                  { label:'Toplam odenen', value:`₺${parseFloat(detay.ozet?.toplam_odenen||0).toLocaleString('tr-TR')}`, bg: isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', tc:'#3B6D11' },
                  { label:'Bekleyen', value:`₺${(parseFloat(detay.ozet?.toplam_birikmis||0) - parseFloat(detay.ozet?.toplam_odenen||0)).toLocaleString('tr-TR')}`, bg: isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA', tc:'#854F0B' },
                ].map((k, i) => (
                  <div key={i} style={{ background:k.bg, borderRadius:8, padding:'12px 14px' }}>
                    <div style={{ fontSize:11, color: textSec, marginBottom:4 }}>{k.label}</div>
                    <div style={{ fontSize:18, fontWeight:600, color:(k as any).tc || textPrimary }}>{k.value}</div>
                  </div>
                ))}
              </div>

              {/* Odeme butonu */}
              <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:14 }}>
                <button onClick={() => { setHata(''); setOdemeModal(true); }}
                  style={{ background:'#1D9E75', color:'white', border:'none', padding:'8px 16px', borderRadius:6, cursor:'pointer', fontSize:13 }}>
                  + Odeme kaydet
                </button>
              </div>

              {/* Yoklama detayi */}
              <div style={{ background: card, border:`1px solid ${border}`, borderRadius:10, overflow:'hidden', marginBottom:14 }}>
                <div style={{ padding:'10px 14px', borderBottom:`1px solid ${border}`, fontSize:13, fontWeight:500, color: textPrimary }}>Yoklama gecmisi</div>
                {detay.detay?.length === 0 ? (
                  <div style={{ padding:20, textAlign:'center', color: textMuted, fontSize:13 }}>Henuz yoklama yok</div>
                ) : (
                  <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                    <thead><tr style={{ borderBottom:`1px solid ${border}` }}>
                      {['Tarih','Ders','Katildi','Gelmedi','Hakedis Orani','Hakedis'].map(h=>(
                        <th key={h} style={{ textAlign:'left', padding:'7px 14px', fontSize:11, color: textMuted, fontWeight:500 }}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {detay.detay?.map((d:any, i:number) => (
                        <tr key={i} style={{ borderBottom:i<detay.detay.length-1?`1px solid ${borderSub}`:'none' }}>
                          <td style={{ padding:'8px 14px', color: isDark ? '#bbb' : '#555' }}>{d.tarih?.slice(0,10)}</td>
                          <td style={{ padding:'8px 14px', fontWeight:500, color: textPrimary }}>{d.ders_adi}</td>
                          <td style={{ padding:'8px 14px' }}><span style={{ background: isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', color:'#3B6D11', borderRadius:20, padding:'1px 8px', fontSize:11 }}>{d.katildi}</span></td>
                          <td style={{ padding:'8px 14px' }}><span style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', borderRadius:20, padding:'1px 8px', fontSize:11 }}>{d.gelmedi}</span></td>
                          <td style={{ padding:'8px 14px', color: isDark ? '#bbb' : '#555' }}>%{d.hakedis_oran}</td>
                          <td style={{ padding:'8px 14px', fontWeight:500, color:'#1D9E75' }}>₺{parseFloat(d.hakedis||0).toLocaleString('tr-TR')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Odeme gecmisi */}
              {detay.odemeler?.length > 0 && (
                <div style={{ background: card, border:`1px solid ${border}`, borderRadius:10, overflow:'hidden' }}>
                  <div style={{ padding:'10px 14px', borderBottom:`1px solid ${border}`, fontSize:13, fontWeight:500, color: textPrimary }}>Odeme gecmisi</div>
                  <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                    <thead><tr style={{ borderBottom:`1px solid ${border}` }}>
                      {['Tarih','Tutar','Yontem','Tip'].map(h=>(
                        <th key={h} style={{ textAlign:'left', padding:'7px 14px', fontSize:11, color: textMuted, fontWeight:500 }}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {detay.odemeler?.map((o:any, i:number) => (
                        <tr key={i} style={{ borderBottom:i<detay.odemeler.length-1?`1px solid ${borderSub}`:'none' }}>
                          <td style={{ padding:'8px 14px', color: isDark ? '#bbb' : '#555' }}>{o.odeme_tarihi?.slice(0,10)}</td>
                          <td style={{ padding:'8px 14px', fontWeight:500, color:'#1D9E75' }}>₺{parseFloat(o.odenen_tutar||0).toLocaleString('tr-TR')}</td>
                          <td style={{ padding:'8px 14px', color: isDark ? '#bbb' : '#555' }}>{o.odeme_yontemi}</td>
                          <td style={{ padding:'8px 14px' }}>
                            <span style={{ background: o.odeme_tipi==='tam'?(isDark?'rgba(29,158,117,0.15)':'#EAF3DE'):(isDark?'rgba(245,158,11,0.15)':'#FAEEDA'), color: o.odeme_tipi==='tam'?'#3B6D11':'#854F0B', borderRadius:20, padding:'2px 8px', fontSize:11 }}>
                              {o.odeme_tipi}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Odeme modali */}
      {odemeModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}
          onClick={e => { if (e.target===e.currentTarget) setOdemeModal(false); }}>
          <div style={{ background: card, borderRadius:12, padding:24, width:380 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:4, color: textPrimary }}>Odeme kaydet</div>
            <div style={{ fontSize:12, color: textSec, marginBottom:16 }}>{secili?.ad} {secili?.soyad}</div>

            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color: textSec, marginBottom:4, fontWeight:500 }}>Odenen tutar (TL)</div>
              <input type="number" value={odemeForm.odenen_tutar} onChange={e=>setOdemeForm(p=>({...p,odenen_tutar:e.target.value}))} placeholder="0.00"
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:`1px solid ${border}`, fontSize:13, boxSizing:'border-box' }} />
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color: textSec, marginBottom:4, fontWeight:500 }}>Odeme yontemi</div>
                <select value={odemeForm.odeme_yontemi} onChange={e=>setOdemeForm(p=>({...p,odeme_yontemi:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:`1px solid ${border}`, fontSize:13 }}>
                  {['Nakit','Kart','EFT','Havale'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color: textSec, marginBottom:4, fontWeight:500 }}>Odeme tipi</div>
                <select value={odemeForm.odeme_tipi} onChange={e=>setOdemeForm(p=>({...p,odeme_tipi:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:`1px solid ${border}`, fontSize:13 }}>
                  <option value="tam">Tam odeme</option>
                  <option value="kismi">Kismi odeme</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color: textSec, marginBottom:4, fontWeight:500 }}>Not (opsiyonel)</div>
              <input value={odemeForm.aciklama} onChange={e=>setOdemeForm(p=>({...p,aciklama:e.target.value}))}
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:`1px solid ${border}`, fontSize:13, boxSizing:'border-box' }} />
            </div>

            {hata && <div style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginBottom:10 }}>{hata}</div>}

            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={() => setOdemeModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background: card, cursor:'pointer', fontSize:13, color: textPrimary }}>Iptal</button>
              <button onClick={odemeKaydet} disabled={kaydediliyor}
                style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#1D9E75', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor ? 'Kaydediliyor...' : 'Odemeyi kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hakedis;
